<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-09-06 15:02:36
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveTransactionPropertyGroup\editLeaveTransactionPropertyGroup.vue
 -->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_leaveTransactionPropertyGroup_form_editTitle')
        : $t('label_essweb_leaveTransactionPropertyGroup_form_viewTitle')
    "
    widthClass="max-1000"
    pad="0"
    delBtn
    :initData="PHGroupData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'leave_transaction_type_property_group_name',
      'leave_transaction_type_property_group_description',
      'leave_transaction_type_property_group_code',
      'remarks',
    ]"
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    @delete="
      $confirmDo(
        $t('label_essweb_leaveTransactionPropertyGroup_list_title')
      ).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  maxlength="100"
                  :readonly="!iSEdited"
                  :bindData="
                    PHGroupData.leave_transaction_type_property_group_name
                  "
                  @change="
                    (valueArr) => {
                      PHGroupData.leave_transaction_type_property_group_name =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_leaveTransactionPropertyGroup_form_groupNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  maxlength="500"
                  :bindData="
                    PHGroupData.leave_transaction_type_property_group_description
                  "
                  @change="
                    (valueArr) => {
                      PHGroupData.leave_transaction_type_property_group_description =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_leaveTransactionPropertyGroup_form_descriptionLabel'
                    )
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :filled="iSEdited"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  maxlength="100"
                  :readonly="!iSEdited"
                  :label="
                    $t(
                      'label_essweb_leaveTransactionPropertyGroup_form_codeLabel'
                    )
                  "
                  v-model="
                    PHGroupData.leave_transaction_type_property_group_code
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t(
                    "label_essweb_leaveTransactionPropertyGroup_form_remarkLabel"
                  )
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  dense
                  :filled="iSEdited"
                  counter="500"
                  single-line
                  :readonly="!iSEdited"
                  v-model="PHGroupData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <PropertyList
            :items="desserts"
            :listdata="PropertyListData"
            @edit="
              (obj) => {
                viewProperty = false;
                toEditProperty(obj);
              }
            "
            @view="
              (obj) => {
                viewProperty = true;
                toEditProperty(obj);
              }
            "
            :canEdit="iSEdited"
          />
        </template>
      </Taber>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited && curTab == 'tab-1'"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <EditMappingPopup3
        :show="showMappingPopup"
        :PropertyData="PropertyData"
        :curGroupId="$route.params.id"
        :view="viewProperty"
        @close="
          showMappingPopup = false;
          PropertyData = null;
        "
        @confirm="onEditProperty"
      />
    </template>
  </ContentLayout>
</template>
<script>
import EditMappingPopup3 from "@/Page/EssAdmin/Leave/LeaveTransactionPropertyGroup/components/EditMappingPopup3.vue";
import { mapGetters } from "vuex";
export default {
  name: "editPublicHolidayGroup",
  components: { EditMappingPopup3 },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      iSEdited: true,
      PropertyData: null,
      isChanged: false,
      PropertyListData: null,
      showMappingPopup: false,
      curTab: "tab-1",
      taber: [
        "label_essweb_leaveTransactionPropertyGroup_form_step_generalLabel",
        "label_essweb_leaveTransactionPropertyGroup_form_step_propertyGroupLabel",
      ],
      mapToDialog: false,
      mapToEditDialog: false,
      viewProperty: false,
      curProperty: null,
      page: 1,
      showSelect: false,
      PHGroupData: {
        leave_transaction_type_property_group_name: "",
        leave_transaction_type_property_group_description: "",
        leave_transaction_type_property_group_code: "",
        remarks: "",
      },
      curCategory: [],
      curPropertyId: null,
      showPGDelete: false,
      desserts: [],
      curUuids: [],
    };
  },
  watch: {},
  mounted() {
    // this.PHGroupData.leave_transaction_type_property_group_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.PHGroupData.leave_transaction_type_property_group_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getGroupDetail();
    this.getPorpertyList();
  },
  methods: {
    getGroupDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type_property_group",
        url: "/leave-transaction-type-property-group/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["leave_transaction_type_property_group_name_save"] =
          res.data.leave_transaction_type_property_group_name;
        res.data.leave_transaction_type_property_group_name =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.leave_transaction_type_property_group_name
          );
        res.data["leave_transaction_type_property_group_description_save"] =
          res.data.leave_transaction_type_property_group_description;
        res.data.leave_transaction_type_property_group_description =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.leave_transaction_type_property_group_description
          );
        that.PHGroupData = res.data;
      });
    },
    toEditProperty: function (obj) {
      this.PropertyData = obj;
      this.showMappingPopup = true;
    },
    onEditProperty: function (obj, deleteArr, changeList) {
      const that = this;
      this.PropertyData = null;
      // obj["changeList"].map((item) => (item["org_level_uuid"] = "002"));
      that.showMappingPopup = false;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type_property",
        url: "/leave-transaction-type-property-group/update/",
        data: {
          uuid: this.$route.params.id,
          property_ids: deleteArr.length ? deleteArr.join(",") : "",
          ess_lv_leave_transaction_type_property: changeList,
        },
      }).then((res) => {
        that.findTreeItem(that.desserts, obj.property_master_code, changeList);
      });
    },
    findTreeItem: function (tree, code, obj) {
      const that = this;
      tree.some((item) => {
        if (item["property_master_code"] === code) {
          item["changeList"] = obj;
          if (item["changeList"].length == 0) {
            item["value"] = "";
          }
          return true;
        } else {
          if (item.children) {
            that.findTreeItem(item.children, code, obj);
          } else {
          }
        }
      });
    },
    getPorpertyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type_property",
        url: "/leave-transaction-type-property/get-list/",
        data: {
          leave_transaction_type_property_group_uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          item["property_master_code"] =
            item.leave_transaction_type_property_master_code;
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type_property_group",
        url: "/leave-transaction-type-property-group/update/",
        data: {
          uuid: this.$route.params.id,
          leave_transaction_type_property_group_name: this.$transCommonLangKey(
            this.PHGroupData.leave_transaction_type_property_group_name,
            this.PHGroupData.leave_transaction_type_property_group_name_save
          ),
          leave_transaction_type_property_group_description:
            this.$transCommonLangKey(
              this.PHGroupData
                .leave_transaction_type_property_group_description,
              this.PHGroupData
                .leave_transaction_type_property_group_description_save
            ),
          leave_transaction_type_property_group_code:
            this.PHGroupData.leave_transaction_type_property_group_code,
          remarks: this.PHGroupData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveTransactionPropertyGroup_list_updateLeaveTransactionPropertyGroupNameLabel"
          ),
          type: "success",
        });
        that.$toBack();
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_property_group",
        url: "/leave-transaction-type-property-group/delete/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveTransactionPropertyGroup_list_deleteLeaveTransactionPropertyGroupNameLabel"
          ),
          type: "success",
        });
        that.$toBack();
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
